import { takeLatest, put, call } from 'redux-saga/effects'
import NProgress from 'nprogress'

import * as CONST from './const'
import { apiClient } from 'Module/API/Client'
import { authorization } from 'Module/Auth/Auth'
import { push } from 'react-router-redux'
import { PATHS } from 'Config/Routing/paths'

/**
 * Login user
 *
 * @param {Object} action
 */
function* loginUser(action) {
  NProgress.start()

  const response = yield call(apiClient.userAuth, {
    email: action.payload.username,
    password: action.payload.password,
  })

  try {
    if (response.ok) {
      const body = yield response.json()

      authorization.login({
        user: body.user,
        apiKey: body.apiKey,
        countryName: body.city ? body.city.country.name : null,
        countryCode: body.city ? body.city.country.code : null,
      })

      yield put({
        type: CONST.AUTH_LOGIN_SUCCESS,
        payload: {
          user: body.user,
          apiKey: body.apiKey,
        },
      })
    } else if (response.status === 400 || response.status === 403) {
      const body = yield response.json()

      yield put({
        type: CONST.AUTH_LOGIN_ERROR,
        payload: {
          errorMessage: body.message,
        },
      })
      authorization.logout()
    }
  } catch (ex) {
    console.error(ex)
  }

  NProgress.done()
}

/**
 * Request reset password
 *
 * @param {Object} action
 */
function* userRequestResetPassword(action) {
  NProgress.start()
  const response = yield call(apiClient.userRequestResetPassword, {
    email: action.payload.email,
  })

  if (response.ok) {
    yield put({
      type: CONST.AUTH_REQUEST_RESET_PASSWORD_SUCCESS,
      payload: {
        email: action.payload.email,
      },
    })
  } else {
    yield put({
      type: CONST.AUTH_REQUEST_RESET_PASSWORD_ERROR,
      payload: {
        errorMessage: 'Something went wrong :( Please contact us or try again',
      },
    })
  }

  NProgress.done()
}

/**
 * Check code and hash valid for password resetting
 * @param action
 */
function* userCheckCodeAndHash(action) {
  NProgress.start()
  const response = yield call(
    apiClient.userCheckCodeAndHash,
    action.payload.hash,
    action.payload.code,
  )

  if (response.ok) {
    yield put({
      type: CONST.AUTH_CHECK_CODE_AND_HASH_SUCCESS,
    })
  } else {
    yield put({
      type: CONST.AUTH_CHECK_CODE_AND_HASH_ERROR,
      payload: {
        errorMessage: 'Sorry, the link is invalid.',
      },
    })
  }

  NProgress.done()
}

/**
 * Reset password
 *
 * @param {Object} action
 */
function* userResetPassword(action) {
  NProgress.start()

  const response = yield call(apiClient.userResetPassword, {
    code: action.payload.code,
    hash: action.payload.hash,
    password: action.payload.password,
  })
  const body = yield response.json()
  // If the user is a distributor then just redirect to a
  // "Your password was reset successfully page".
  if (body.user.role == 'DISTRIBUTOR') {
    yield put(push(PATHS.main.resetPassSuccess))
    return
  }
  authorization.login(body.user, body.apiKey)

  if (response.ok) {
    yield put({
      type: CONST.AUTH_RESET_PASSWORD_SUCCESS,
      payload: {
        user: body.user,
        apiKey: body.apiKey,
      },
    })
  } else {
    yield put({
      type: CONST.AUTH_RESET_PASSWORD_ERROR,
      payload: {
        errorMessage: body.message,
      },
    })
  }

  NProgress.done()
}

/**
 * Login user watcher
 */
export function* watchLoginUser() {
  yield takeLatest(CONST.AUTH_LOGIN, loginUser)
}

/**
 * Request for resetting the password
 */
export function* watchUserRequestResetPassword() {
  yield takeLatest(CONST.AUTH_REQUEST_RESET_PASSWORD, userRequestResetPassword)
}

/**
 * Check code and hash for password resetting
 */
export function* watchCheckCodeAndHash() {
  yield takeLatest(CONST.AUTH_CHECK_CODE_AND_HASH, userCheckCodeAndHash)
}

/**
 * Resetting password
 */
export function* watchUserResetPassword() {
  yield takeLatest(CONST.AUTH_RESET_PASSWORD, userResetPassword)
}



// WEBPACK FOOTER //
// ./src/Reducers/Auth/sagas.js